<template>
  <b-row class="order-workspace" style="height: auto; overflow: auto">
    <!-- HEADER -->

    <b-col cols="12">
      <b-card
        v-if="!!option"
        id="page-order-form-1"
        no-body
        class="order-toolbar mb-0"
      >
        <b-card-body class="order-toolbar-body">
          <div class="order-toolbar-content">
            <div class="order-toolbar-main">
              <div class="order-toolbar-icon">
                <feather-icon icon="ShoppingBagIcon" size="24" />
              </div>
              <div>
                <small class="order-toolbar-eyebrow">
                  {{ $t(label("orderWorkspace")) }}
                </small>
                <h2 class="mb-25">{{ $t(label(orderPageTitle)) }}</h2>
                <div v-if="option !== 1" class="order-toolbar-meta">
                  <span>#{{ order.idOrder || "-" }}</span>
                  <span v-if="order.nameClient">{{ order.nameClient }}</span>
                  <span>{{ formatDate(order.date) }}</span>
                </div>
              </div>
            </div>

            <div class="order-toolbar-actions">
              <b-badge
                v-if="option !== 1"
                pill
                class="order-status-badge"
                :variant="order.colorStatus || statusVariant(order.nameStatus)"
              >
                {{ order.nameStatus || "-" }}
              </b-badge>
              <b-button variant="outline-secondary" @click="goBack">
                <feather-icon icon="ArrowLeftIcon" class="mr-50" />
                {{ $t("back") }}
              </b-button>
            </div>
          </div>
        </b-card-body>
      </b-card>
    </b-col>

    <b-col cols="12" sm="12" md="12" lg="12" xl="12">
      <b-row class="order-overview-row">
        <b-col v-if="option === 1" cols="12" sm="12" md="12" lg="12" xl="12">
          <!-- CLIENT -->
          <add-client
            :option="option"
            :block-status="blockStatus"
            :order="order"
            @user-selected="handleUserSelected"
            @payments-selected="handlePaymentsSelected"
          ></add-client>
        </b-col>

        <!-- CUSTOMER DETAIL -->
        <b-col
          v-if="option !== 1"
          cols="12"
          md="6"
          class="order-overview-column"
        >
          <customer-detail
            :option="option"
            :block-status="blockStatus"
            :customer="order"
            @edit-order="onEdit"
          />

          <timeline-order
            :option="option"
            :block-status="blockStatus"
            :histories="order.statusHistory"
            :name-status="order.nameStatus"
            :status="order.idCatStatus"
            @changeStatus="updateStatus"
            @edit-order="onEdit"
          />
        </b-col>
        <!-- ORDER SUMMARY -->
        <b-col cols="12" sm="12" md="6" lg="6" xl="6">
          <b-card class="mt-2 order-summary-card">
            <div class="section-heading mb-2">
              <div class="section-heading-icon">
                <feather-icon icon="DollarSignIcon" size="19" />
              </div>
              <div>
                <h4 class="mb-25">{{ $t(label("orderSummary")) }}</h4>
                <small class="text-muted">{{
                  $t(label("orderSummaryHelp"))
                }}</small>
              </div>
            </div>
            <div class="summary-row">
              <span class="text-muted">{{ $t(label("subtotal")) }}</span>
              <strong>{{ formatAmount(primarySubtotal) }} {{ divisa }}</strong>
            </div>
            <div class="summary-row">
              <span class="text-muted">{{
                $t(label("iva"), { rate: formatRate(ivaRate) })
              }}</span>
              <strong>{{ formatAmount(ivaAmount) }} {{ divisa }}</strong>
            </div>
            <div class="summary-row font-weight-bolder">
              <span>{{ $t(label("totalWithIva")) }}</span>
              <strong>{{ formatAmount(totalWithIva) }} {{ divisa }}</strong>
            </div>
            <hr />
            <!-- <div class="summary-row">
              <span class="text-muted">{{ $t(label("subtotalInBolivars")) }}</span>
              <strong>{{ formatAmount(bolivarSubtotal) }} Bs</strong>
            </div>
            <div class="summary-row">
              <span class="text-muted">{{
                $t(label("ivaInBolivars"), { rate: formatRate(ivaRate) })
              }}</span>
              <strong>{{ formatAmount(bolivarIvaAmount) }} Bs</strong>
            </div>
            <div class="summary-row mb-0 font-weight-bolder">
              <span>{{ $t(label("totalInBolivars")) }}</span>
              <strong>{{ formatAmount(totalInBolivars) }} Bs</strong>
            </div>
            <hr /> -->
            <div>
              <span class="text-muted d-block mb-50">{{
                $t(label("notes"))
              }}</span>
              <p class="mb-0 order-notes">
                {{ order.notes || $t(label("noNotes")) }}
              </p>
            </div>
          </b-card>
        </b-col>

        <!-- SHIPPING INFORMATION -->
        <!-- <b-col v-if="option !== 1" cols="12">
          <b-card class="order-detail-card" :title="$t(label('shippingInformation'))">
            <b-row v-if="shippingDetails.length">
              <b-col
                v-for="(detail, index) in shippingDetails"
                :key="`shipping-${index}`"
                cols="12"
                md="6"
                class="mb-1"
              >
                <div class="shipping-detail">
                  <feather-icon icon="MapPinIcon" size="17" class="mr-75 text-primary" />
                  <span>{{ detail }}</span>
                </div>
              </b-col>
            </b-row>
            <p v-else class="mb-0 text-muted">{{ $t(label("notAvailable")) }}</p>
          </b-card>
        </b-col> -->

        <!-- PAYMENT INFORMATION -->
        <!-- <b-col v-if="option !== 1" cols="12" md="6">
          <b-card
            class="order-detail-card"
            :title="$t(label('paymentInformation'))"
          >
            <div class="summary-row">
              <span class="text-muted">{{ $t(label("type_payment")) }}</span>
              <strong>{{ order.nameTypePaymentMethods || "-" }}</strong>
            </div>
            <div class="summary-row">
              <span class="text-muted">{{ $t(label("information")) }}</span>
              <strong class="text-right payment-information">
                {{ order.informationPaymentMethods || "-" }}
              </strong>
            </div>
            <div class="summary-row mb-0">
              <span class="text-muted">{{ $t(label("paymentRecords")) }}</span>
              <strong>{{ order.payment.length }}</strong>
            </div>
          </b-card>
        </b-col> -->
      </b-row>
    </b-col>
    <!-- PRODUCT -->
    <b-col sm="12" md="12" lg="12" xl="12">
      <add-product
        :option="option"
        :block-status="blockStatus"
        :customer="order"
        :selectedProductsGet="productsForCreate"
        :reference-date="pricingReferenceDate"
        @products-selected="handleProductSelected"
        @delete-product="deleteProduct"
      ></add-product>
    </b-col>

    <!-- DETAIL ORDER -->
    <b-col sm="12" md="12" lg="12" xl="12">
      <b-row>
        <b-col cols="12">
          <payment-process
            :option="option"
            :block-status="blockStatus"
            :payments="paymentsForUptade"
            :payment-methods="paymentMethods"
            :detail="order"
            :products-subtotal="calculatedProductsSubtotal"
            :company-guid="companyGuid"
            @updatePeyment="handleDataPayment"
            @back="goBack"
            @submit="onSubmit"
          />
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import _ from "lodash";
import { heightTransition } from "@core/mixins/ui/transition";
import { FormWizard, TabContent, WizardButton } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import vSelect from "vue-select";
import {
  BCard,
  BCardHeader,
  BCardTitle,
  BCardBody,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BFormGroup,
  BFormCheckbox,
  BForm,
  BFormTextarea,
  BFormSelect,
  BFormRadio,
  BFormRadioGroup,
  BFormInvalidFeedback,
  BFormCheckboxGroup,
} from "bootstrap-vue";
import AppTimeline from "@core/components/app-timeline/AppTimeline.vue";
import AppTimelineItem from "@core/components/app-timeline/AppTimelineItem.vue";
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
import router from "@/router";
import {
  createOrderPayment,
  getOrder,
  createOrderProduct,
  updateOrderProducts,
  changeStatus,
} from "@core/api/request/orders";
import { getCatalog } from "@core/api/request/catalogs";
import { allClientsByCompany } from "@core/api/request/clients";
import { allProducts } from "@core/api/request/products";

import TimelineOrder from "./TimelineOrder.vue";
import PaymentProcess from "./PaymentProcess.vue";
import AddProduct from "./AddProduct.vue";
import AddClient from "./AddClient.vue";
import CustomerDetail from "./CustomerDetail.vue";
import ListProducts from "./ListProducts.vue";
import DetailOrder from "./DetailOrder.vue";
import Chat from "../../chat/Chat.vue";
import { createSignalRConnection } from "@core/api/request/signalr";

import { getParams, showLoading, stopLoading } from "@core/utils/utils";
import Ripple from "vue-ripple-directive";
import moment from "moment";
import { orderSubtotal } from "./orderProductPricing";

const order = {
  guid: null,
  guidCompany: null,
  idClient: null,
  idCatStatus: null,
  products: [],
  statusHistory: [],
  addressClient: null,
  amount: 0,
  amountVES: 0,
  amountVESTasaConfigurada: 0,
  characteristics: null,
  colorStatus: null,
  colorTypePaymentMethods: null,
  date: null,
  delivery: null,
  emailClient: null,
  idCatTypePaymentMethods: null,
  idCompany: null,
  idCompanyPaymentMethods: null,
  idOrder: null,
  informationPaymentMethods: null,
  nameClient: null,
  nameStatus: null,
  nameTypePaymentMethods: null,
  payment: [],
  phoneClient: null,
  products: [],
  shipping: null,
  shippingAddress: null,
  shippingAddressClient: null,
  totalToPay: 0,
  totalToPayVES: 0,
  totalToPayVESTasaConfigurada: 0,
  url: null,
  notes: null,
  orderType: null,
};

export default {
  components: {
    TimelineOrder,
    PaymentProcess,
    DetailOrder,
    CustomerDetail,
    ListProducts,
    AppTimeline,
    AppTimelineItem,
    FormWizard,
    TabContent,
    WizardButton,
    BFormInvalidFeedback,
    vSelect,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BFormCheckboxGroup,
    BForm,
    BFormTextarea,
    BFormSelect,
    BFormRadio,
    BFormRadioGroup,
    ValidationProvider,
    ValidationObserver,
    Chat,
    AddProduct,
    AddClient,
  },
  directives: {
    Ripple,
  },
  mixins: [heightTransition],
  data: () => ({
    option: null,
    blockStatus: false,
    connection: null,
    isSaveMode: true,
    order: Object.assign(order),
    listCatStatus: [],
    companyGuid: null,
    guidProd: null,
    quantity: null,

    nextTodoId: 1,
    itemsPage: 1,
    itemsRows: 999,
    totalRows: 0,
    currentPage: 1,
    perPage: 5,

    productsForCreate: [],
    userForCreate: null,
    paymentMethods: [],
    paymentsForUptade: [],
  }),

  computed: {
    orderPageTitle() {
      if (this.option === 1) return "createOrder";
      if (this.option === 2) return "viewOrder";
      return "manageOrder";
    },
    divisa() {
      return this.$store.state.appConfig.divisa || "USD";
    },
    ivaRate() {
      const rate = Number(this.$store.state.appConfig.iva);
      return Number.isFinite(rate) && rate >= 0 && rate <= 100 ? rate : 0;
    },
    pricingReferenceDate() {
      return this.option === 1 ? new Date() : this.order.date || new Date();
    },
    calculatedProductsSubtotal() {
      return orderSubtotal(this.productsForCreate, this.pricingReferenceDate);
    },
    primarySubtotal() {
      return this.calculatedProductsSubtotal;
    },
    primaryTotal() {
      return this.primarySubtotal;
    },
    ivaAmount() {
      return this.primarySubtotal * (this.ivaRate / 100);
    },
    totalWithIva() {
      return this.primaryTotal + this.ivaAmount;
    },
    bolivarSubtotal() {
      const officialPrimarySubtotal = this.firstPositiveAmount([
        this.order.amount,
        this.order.totalToPay,
      ]);
      const officialBolivarSubtotal = this.firstPositiveAmount([
        this.order.amountVESTasaConfigurada,
        this.order.amountVES,
      ]);
      if (officialPrimarySubtotal > 0 && officialBolivarSubtotal > 0) {
        return (
          this.primarySubtotal *
          (officialBolivarSubtotal / officialPrimarySubtotal)
        );
      }
      return this.firstPositiveAmount([
        this.order.amountVESTasaConfigurada,
        this.order.amountVES,
      ]);
    },
    bolivarTotal() {
      return this.bolivarSubtotal;
    },
    bolivarIvaAmount() {
      return this.bolivarSubtotal * (this.ivaRate / 100);
    },
    totalInBolivars() {
      return this.bolivarTotal + this.bolivarIvaAmount;
    },
    shippingDetails() {
      const value =
        this.order.shippingAddressClient ||
        this.order.shippingAddress ||
        this.order.addressClient ||
        "";
      return value
        .split("|")
        .map((item) => item.trim())
        .filter(Boolean);
    },
  },

  created() {
    localize("es");

    this.companyGuid = this.$store.state.appConfig.activeCompanyGuid;
    window.addEventListener("resize", this.initTrHeight);

    this.initialize();
  },

  watch: {
    "$store.state.appConfig.activeCompanyGuid"(guid) {
      this.companyGuid = guid;
      this.order.guidCompany = guid;
    },
  },

  mounted() {
    this.initTrHeight();
  },

  destroyed() {
    window.removeEventListener("resize", this.initTrHeight);
  },

  methods: {
    label(field) {
      return `pages.orders.form.label.${field}`;
    },

    labelHeader(field) {
      return `pages.orders.table.tableHeader.${field}`;
    },

    formatAmount(value) {
      if (value === null || value === undefined || value === "") return "-";
      const amount = Number(value);
      if (Number.isNaN(amount)) return value;
      return amount.toLocaleString(this.$i18n.locale || "es-VE", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },

    formatRate(value) {
      const rate = Number(value);
      return Number.isFinite(rate) ? rate.toLocaleString(this.$i18n.locale) : 0;
    },

    toValidAmount(value) {
      const amount = Number(value);
      return Number.isFinite(amount) ? amount : 0;
    },

    firstValidAmount(values) {
      const value = values.find((item) => Number.isFinite(Number(item)));
      return this.toValidAmount(value);
    },

    firstPositiveAmount(values) {
      const value = values.find((item) => {
        const amount = Number(item);
        return Number.isFinite(amount) && amount > 0;
      });
      return this.toValidAmount(value);
    },

    formatDate(value) {
      if (!value) return "-";
      return moment(value).format("DD/MM/YYYY HH:mm");
    },

    statusVariant(status) {
      switch (status) {
        case "Generada":
          return "light-info";
        case "Atendida":
          return "light-warning";
        case "Procesada":
          return "light-primary";
        case "Terminada":
          return "light-success";
        case "Cancelada":
          return "light-danger";
        default:
          return "light-secondary";
      }
    },

    isStatus(value) {
      return value !== "Generada";
    },

    getTitle() {
      if (this.option === 1) return "register";
      else if (this.option === 2) return "show";
      else if (this.option === 3) return "detail";
    },

    handleDataPayment(payInfo) {
      this.paymentsForUptade.push(payInfo);
      this.order.payment = this.paymentsForUptade;
    },

    chargeParams(key) {
      let arrParams = [];

      arrParams.push(`itemsPage,${this.itemsPage}`);

      arrParams.push(`itemsRows,${this.itemsRows}`);

      switch (key) {
        case "status":
          arrParams.push("guidCatalog, 1a9be8bf-50d7-41b6-b33c-594b0699b1a9");
          break;
      }

      return getParams(arrParams);
    },

    removeItem(index) {
      this.frequentQuestions.splice(index, 1);
      this.trTrimHeight(this.$refs.row[0].offsetHeight);
    },

    initTrHeight() {
      this.trSetHeight(null);
      this.$nextTick(() => {
        if (!!this.$refs.formList) {
          this.trSetHeight(this.$refs.formList.scrollHeight);
        }
      });
    },

    async initialize() {
      this.option = this.$route.params.option;

      if (this.option === undefined) {
        router.push({ name: "orders" }).catch(() => {});
      }
      this.loadCatData();
      switch (this.option) {
        case 1:
          this.onCancel();
          // this.loadCustomers();
          break;
        case 2:
        case 3:
          if (this.$route.params.idOrder === undefined) {
            router.push({ name: "orders" }).catch(() => {});
          }
          this.isSaveMode = this.option !== 2;
          // this.loadOrder(this.$route.params.idOrder);

          await Promise.all([
            // this.loadCustomers(),
            this.loadOrder(this.$route.params.idOrder),
          ]);
          // Crea la conexión SignalR
          // this.connection = createSignalRConnection("ordersHub");

          // Inicia la conexión SignalR
          // this.startSocket()
          break;
      }
    },

    onSubmit() {
      if (this.productsForCreate.length === 0) {
        this.alertToast(
          "danger",
          "Alerta",
          "Debes seleccionar al menos un producto",
        );
        return;
      }
      showLoading();
      const data = {
        idOrder: this.order.idOrder || null,
        guidCompany: this.companyGuid,
        idClient: this.userForCreate?.idClient || this.order.idClient,
        idCatStatus:
          this.option === 1
            ? this.listCatStatus.find((model) => model.name === "Generada").id
            : this.order.idCatStatus,
        idCompanyPaymentMethods: null,
        shippingAddress:
          this.userForCreate?.shippingAddress || this.order.shippingAddress,
        delivery: true,
        characteristics: "",
        products: this.getProductForm(this.productsForCreate),
        payment: this.getPaymentsForm(this.order.payment),
      };

      const action =
        this.option === 1 ? createOrderProduct : updateOrderProducts;

      action(data)
        .then((resp) => {
          stopLoading();

          let message =
            this.option === 1 ? "Registro exitoso" : "Actualizacion exitosa";
          this.alertToast("success", "Alerta", message);
          this.option = 2;
          this.blockStatus = false;
          this.loadOrder(resp.data);
        })
        .catch((error) => {
          console.log("error", error);
          stopLoading();
          this.alertToast("danger", "Alerta error", error.message);
        });
    },

    async startSocket() {
      // Inicia la conexión SignalR
      try {
        await this.connection
          .start()
          .then(() => {
            console.log("Conexión SignalR iniciada correctamente");
            this.socketOrder();
          })
          .catch((error) => {
            console.log("Error al iniciar la conexión SignalR:", error);
          });
      } catch (error) {
        console.log("Error al conectar a SignalR:", error);
        this.reconnectSocket();
      }
    },

    reconnectSocket() {
      try {
        console.log("Intentando reconectar a SignalR...");
        this.startSocket();
      } catch (error) {
        console.log("Error al reconectar a SignalR:", error);
        setTimeout(() => this.reconnectSocket(), 5000);
      }
    },

    socketOrder() {
      try {
        const guidCompany = this.companyGuid;
        if (guidCompany) {
          this.connection
            .invoke("JoinGroup", guidCompany)
            .then(() => {
              console.log("Unido al grupo:", guidCompany);

              // this.connection.off("OrderCreated")
              this.connection.on("OrderCreated", (data) => {
                console.log("OrderCreated recibida ----->:", parseFloat(data));
                this.handleOrderNotification(parseFloat(data));
              });
            })
            .catch((err) => {
              console.log("Error al unirse al grupo SignalR:", err);
            });
        }
      } catch (error) {
        console.log("Error al conectar a SignalR:", error);
      }
    },

    handleOrderNotification(data) {
      if (data === this.order.idOrder) this.loadOrder(data);
    },

    async loadOrder(orderId) {
      const param = getParams([`idOrder, ${orderId}`]);
      await getOrder(param)
        .then((resp) => {
          const data = _.get(resp, "data") || [];
          this.order = data;

          this.productsForCreate = this.order.products || [];
          this.paymentsForUptade = this.order.payment || [];
          this.blockStatus = this.isStatus(this.order.nameStatus);
          this.handlePaymentsSelected(this.order.payment);
        })
        .catch((error) => {
          console.log("error --->", error);
          this.alertToast("danger", `Alerta codigo`, error.message);
        });
    },

    async loadCatData() {
      showLoading();
      try {
        const paramCatStatus = this.chargeParams("status");
        const [resultCatStatus] = await Promise.all([
          getCatalog(paramCatStatus),
        ]);
        stopLoading();
        this.listCatStatus = _.get(resultCatStatus, "data.listOfItems.items");
      } catch (error) {
        console.log("error", error);
        stopLoading();
        this.alertToast("danger", `Alerta codigo`, error.message);
      }
    },

    updateStatus(value) {
      if (!value) {
        this.alertToast(
          "danger",
          `Alerta`,
          "Debes seleccionar un estado para actualizar",
        );
        return;
      }

      const data = {
        idOrder: this.order.idOrder,
        idCatStatus: value,
      };

      changeStatus(data)
        .then((resp) => {
          this.order.idCatStatus = value;
          this.loadOrder(this.order.idOrder);
          if (resp.status === 500) {
            this.alertToast("danger", `Alerta`, resp.data.message);
            this.disabledButton = false;
            return;
          }

          this.alertToast("success", `Alerta codigo`, resp.data);
          this.disabledButton = false;
          this.$emit("changeorder");
        })
        .catch((error) => {
          console.log("error", error);
          this.loading = !this.loading;
          this.alertToast("danger", `Alerta codigo`, error.message);
        });
    },

    getPaymentsForm(payments) {
      return payments.map((payment) => ({
        amount: payment.amount,
        reference: payment.reference,
        urlReference: payment.urlReference,
        idCompanyPaymentMethods: payment.idCompanyPaymentMethods,
        idCatStatus: payment.idCatStatus,
      }));
    },

    getProducts(companyId) {
      const param = getParams([
        `guidCompany,${companyId}`,
        "page,1",
        "rows,999",
      ]);
      allProducts(param)
        .then((result) => {
          const resul = _.get(result, "data.items") || [];
        })
        .catch((error) => {
          console.log("error", error);
          this.alertToast("danger", `Alerta codigo`, error.message);
        });
    },

    async loadCustomers() {
      try {
        const arrParams = getParams([
          `page,1`,
          `rows,10000`,
          `active,${true}`,
          `guidCompany,${this.companyGuid}`,
        ]);
        const response = await allClientsByCompany(arrParams);
        const customers = _.get(response, "data.items", []);
        this.customers = customers.map((item) => ({
          label: `${item.name} ${item.lastName}`,
          name: undefined,
          idClient: item.idClient,
        }));
      } catch (error) {
        console.error("Error loading customers:", error.message);
      }
    },

    handlePageChange(value) {
      this.currentPage = value;
    },

    add() {
      if (!this.name && !this.guidProd && !this.quantity) {
        this.alertToast(
          "danger",
          "Alerta",
          "Se requiere el producto y cantidad",
        );
        return;
      }

      const random = () => ((1 + Math.random()) * 0x100000) | 0;
      const block = () =>
        (+moment.now() + random() + random() + random()).toString(16);
      const id = `${block()}-${block()}-${block()}`;
      this.order.products.push({
        id: id,
        guid: this.guidProd,
        quantity: this.quantity,
      });
      this.totalRows = this.order.products.length;
      this.quantity = 0;
      this.guidProd = null;
    },

    onDelete(item) {
      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("willNotBeAble"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("yesDelete"),
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          if (item.uuid) {
            const index = this.order.products.findIndex(
              (model) => model.id === item.id,
            );
            this.order.products.splice(index, 1);
          }
          this.totalRows = this.order.productslength;
        } else if (result.dismiss === "cancel") {
          this.message(
            this.$t("canceled"),
            this.$t("registerDeletedCanceled"),
            "error",
          );
        }
      });
    },

    deleteProduct() {
      this.loadOrder(this.$route.params.idOrder);
    },

    getProductForm(products) {
      return products.map((product) => ({
        guid: product.guid,
        quantity: parseInt(product.quantity),
      }));
    },

    handleProductSelected(productsSelected) {
      this.productsForCreate = productsSelected;
      this.order.products = this.productsForCreate;
    },

    handleUserSelected(userSelected) {
      this.userForCreate = userSelected;
      this.order.idClient = userSelected.idClient;
    },

    handlePaymentsSelected(payments) {
      this.paymentMethods = payments.map((payment) => ({
        idCompanyPaymentMethods: payment.idCompanyPaymentMethods,
        nameType: payment.nameType,
      }));
    },

    onEdit() {
      this.option = 3;
    },

    alertToast(type = null, title = null, message = null) {
      this.$bvToast.toast(message, {
        title,
        variant: type,
        solid: true,
        icon: "CoffeeIcon",
      });
    },

    goBack() {
      this.onCancel();
      router.back();
    },

    message(title, text, icon, html) {
      this.$swal({
        title,
        text,
        html,
        icon,
        customClass: {
          confirmButton: "btn btn-success",
        },
      });
    },

    onCancel() {
      Object.assign(this.order, {
        guid: null,
        guidCompany: null,
        idClient: null,
        idCatStatus: null,
        products: [],
        statusHistory: [],
        addressClient: null,
        amount: 0,
        amountVES: 0,
        amountVESTasaConfigurada: 0,
        characteristics: null,
        colorStatus: null,
        colorTypePaymentMethods: null,
        date: null,
        delivery: null,
        emailClient: null,
        idCatTypePaymentMethods: null,
        idCompany: null,
        idCompanyPaymentMethods: null,
        idOrder: null,
        informationPaymentMethods: null,
        nameClient: null,
        nameStatus: null,
        nameTypePaymentMethods: null,
        payment: [],
        phoneClient: null,
        products: [],
        shipping: null,
        shippingAddress: null,
        shippingAddressClient: null,
        statusHistory: [],
        totalToPay: 0,
        totalToPayVES: 0,
        totalToPayVESTasaConfigurada: 0,
        url: null,
        notes: null,
        orderType: null,
      });
      this.quantity = 0;
      this.guidProd = null;
    },
  },

  beforeDestroy() {
    if (this.connection) {
      // Desuscribirse de los eventos de SignalR
      this.connection
        .stop()
        .then(() => {
          console.log("Conexión SignalR de ordenes cerrada correctamente");
        })
        .catch((error) => {
          console.log("Error al cerrar la conexión SignalR de ordenes:", error);
        });
    }
  },
};
</script>

<style lang="scss">
@import "~@core/scss/vue/libs/vue-wizard.scss";
@import "~@core/scss/vue/libs/vue-select.scss";
@import "../../../../public/loader.css";
@import "@core/scss/vue/libs/vue-select.scss";
@import "~@core/scss/base/pages/app-ecommerce.scss";
@import "~vue-form-wizard/dist/vue-form-wizard.min.css";
</style>

<style lang="scss" scoped>
.order-summary-card,
.order-detail-card {
  // height: calc(100% - 1rem);
}

.order-toolbar {
  overflow: hidden;
  border: 0;
  border-left: 4px solid #7367f0;
  border-radius: 0.65rem;
  box-shadow: 0 4px 18px rgba(34, 41, 47, 0.08);
}

.order-toolbar-body {
  padding: 1.4rem 1.5rem;
}

.order-toolbar-content,
.order-toolbar-main,
.order-toolbar-actions,
.section-heading {
  display: flex;
  align-items: center;
}

.order-toolbar-content {
  justify-content: space-between;
  gap: 1.5rem;
}

.order-toolbar-main {
  min-width: 0;
  gap: 1rem;
}

.order-toolbar-icon,
.section-heading-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  color: #7367f0;
  background: rgba(115, 103, 240, 0.12);
}

.order-toolbar-icon {
  width: 3.25rem;
  height: 3.25rem;
  border-radius: 0.75rem;
}

.order-toolbar-eyebrow {
  display: block;
  margin-bottom: 0.15rem;
  color: #7367f0;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.order-toolbar-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem 1rem;
  color: inherit;
  font-size: 0.9rem;
  opacity: 0.75;
}

.order-toolbar-meta span + span::before {
  content: "•";
  margin-right: 1rem;
  color: #b9b9c3;
}

.order-toolbar-actions {
  flex: 0 0 auto;
  gap: 0.75rem;
}

.order-status-badge {
  padding: 0.55rem 0.85rem;
  font-size: 0.85rem;
}

.order-summary-card {
  border: 0;
  border-radius: 0.65rem;
  box-shadow: 0 4px 18px rgba(34, 41, 47, 0.08);
}

.section-heading {
  gap: 0.85rem;
}

.section-heading-icon {
  width: 2.65rem;
  height: 2.65rem;
  border-radius: 0.65rem;
}

.order-overview-row {
  align-items: flex-start;
}

.order-overview-column {
  display: flex;
  flex-direction: column;
}

.summary-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 1rem;
  margin-bottom: 0.75rem;
}

.shipping-detail {
  display: flex;
  align-items: flex-start;
  height: 100%;
  padding: 0.75rem;
  border-radius: 0.357rem;
  background: rgba(115, 103, 240, 0.06);
}

.payment-information {
  max-width: 65%;
  white-space: pre-line;
}

.order-notes {
  white-space: pre-line;
}

@media (max-width: 767.98px) {
  .order-toolbar-content,
  .order-toolbar-actions {
    width: 100%;
  }

  .order-toolbar-content {
    flex-direction: column;
    align-items: flex-start;
  }

  .order-toolbar-actions {
    justify-content: space-between;
  }

  .order-toolbar-meta {
    flex-direction: column;
    gap: 0.15rem;
  }

  .order-toolbar-meta span + span::before {
    display: none;
  }

  .summary-row {
    flex-direction: column;
    gap: 0.25rem;
  }

  .payment-information {
    max-width: 100%;
    text-align: left !important;
  }
}
</style>
